import Welcome from './Welcome';
import SelectContext from './SelectContext';
import Instructions from './Instructions';
import DraftTesters from './DraftTesters';
import Syncing from './Syncing';

export default [
  {
    name: 'Calendar welcome',
    path: '/calendar/welcome',
    exact: true,
    component: Welcome,
  },
  {
    name: 'Calendar select context',
    path: '/calendar/select-context',
    exact: true,
    component: SelectContext,
  },
  {
    name: 'Calendar instructions',
    path: '/calendar/instructions',
    exact: true,
    component: Instructions,
  },
  {
    name: 'Calendar draft testers',
    path: '/calendar/draft-testers',
    exact: true,
    component: DraftTesters,
  },
  {
    name: 'Calendar syncing',
    path: '/calendar/syncing',
    exact: true,
    component: Syncing,
  },
];
